/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Coding_No_Complicated_SetuInputs */

const en_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No coding. No complicated setups. Just pure hustle.`)
};

const es_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin código. Sin configuraciones complicadas. Solo pura dedicación.`)
};

const fr_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de codage. Pas de configurations compliquées. Juste de la pure motivation.`)
};

const de_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Programmieren. Keine komplizierten Setups. Einfach pures Geschäft.`)
};

const ja_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーディング不要。複雑な設定も不要。あなたの情熱を形にするだけです。`)
};

const zh_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需编程。没有复杂的设置。只有纯粹的商业动力。`)
};

const ar_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدون برمجة. بدون إعدادات معقدة. فقط انطلق بتركيز.`)
};

const id_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanpa coding. Tanpa pengaturan rumit. Murni kerja keras.`)
};

const it_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun codice. Nessuna configurazione complicata. Solo pura dedizione.`)
};

const ru_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без программирования. Без сложных настроек. Только чистый бизнес.`)
};

const pt_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem códigos. Sem configurações complicadas. Apenas puro negócio.`)
};

const ko_no_coding_no_complicated_setu = /** @type {(inputs: No_Coding_No_Complicated_SetuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코딩 불필요. 복잡한 설정 불필요. 오직 순수한 열정만 있으면 됩니다.`)
};

/**
* | output |
* | --- |
* | "No coding. No complicated setups. Just pure hustle." |
*
* @param {No_Coding_No_Complicated_SetuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_coding_no_complicated_setu = /** @type {((inputs?: No_Coding_No_Complicated_SetuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Coding_No_Complicated_SetuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_coding_no_complicated_setu(inputs)
	if (locale === "es") return es_no_coding_no_complicated_setu(inputs)
	if (locale === "fr") return fr_no_coding_no_complicated_setu(inputs)
	if (locale === "de") return de_no_coding_no_complicated_setu(inputs)
	if (locale === "ja") return ja_no_coding_no_complicated_setu(inputs)
	if (locale === "zh") return zh_no_coding_no_complicated_setu(inputs)
	if (locale === "ar") return ar_no_coding_no_complicated_setu(inputs)
	if (locale === "id") return id_no_coding_no_complicated_setu(inputs)
	if (locale === "it") return it_no_coding_no_complicated_setu(inputs)
	if (locale === "ru") return ru_no_coding_no_complicated_setu(inputs)
	if (locale === "pt") return pt_no_coding_no_complicated_setu(inputs)
	return ko_no_coding_no_complicated_setu(inputs)
});